import { Button } from 'components';
import { TOKEN_BY_ADDRESS } from 'consts';
import { Address } from 'viem';
import { useWatchAsset } from 'wagmi';

export const AddTokenButton = ({
  tokenAddress,
  chainId,
}: {
  tokenAddress: Address | null | undefined;
  chainId: number;
}) => {
  const { watchAssetAsync, isPending } = useWatchAsset();
  const token = tokenAddress ? TOKEN_BY_ADDRESS[chainId][tokenAddress] : null;

  const handleClick = async (ev: React.MouseEvent) => {
    if (!token) return;
    ev.stopPropagation();

    try {
      await watchAssetAsync({
        type: 'ERC20',
        options: {
          address: token.address,
          symbol: token.symbol,
          decimals: token.decimals,
          image: token.logoURI,
        },
      });
    } catch (err) {
      console.log('add token to wallet err', err);
    }
  };

  if (token?.tags?.includes('native') || !token) return null;

  return (
    <Button
      variant="outlined"
      size="small"
      isFullWidth
      isLoading={isPending}
      onClick={handleClick}
      style={{ margin: '24px -12px 0px', width: 'calc(100% + 24px)' }}
    >
      Add {token.symbol} to Wallet
    </Button>
  );
};
